

/*--------------------
* Service Section
----------------------*/
function Service(props) {
    return (
        <>
            <div className="lg:col-span-6">
                <div className={props.id.main + " feature-box-01"}>
                    <div className="icon"><img src={props.id.icon} alt=""></img></div>
                    <div className="feature-content">
                        <h5>{props.title}</h5>
                        <p>{props.description}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

/*--------------------
* Service List Section
----------------------*/
export default function ServiceList() {
    const service_list = [
        {id:
            {main:'bg-[#FFE9C7]', icon: '../img/icon1_1.gif'},
            title:'Diseño Y Desarrollo Web',
            description:'Tu negocio o proyecto necesita una página web? No te preocupes, te ayudamos a crearla, distinguete de los demás con una página web personalizada y creativa. Hecha de manera artesanal, código limpio y optimizada para que tu negocio crezca.'
        },
        {id:{main:'bg-[#FFE9C7]', icon:'../img/icon2.gif'}, title:'Personalización de CRM', description:'Te ayudamos a gestionar las ventas, clientes, suscripciones, en fin, todo lo que requieres para que tus clientes esten felices y tú, no tengas que preocuparte por recordarles una fecha de pago. Analizamos cada una de tus necesidades y transformamos la experiencia de tus usuarios y tu negocio.'},
        {id:{main:'bg-[#FFE9C7]', icon:'../img/icon3_1.gif'}, title:'SEO Marketing', description:'No logras posicionar tu negocio en Google? No te preocupes, te ayudamos a vincular tu sitio web con los mejores motores de búsqueda y las palabras clave adecuadas.'},
        {id:{main:'bg-[#FFE9C7]', icon:'../img/icon4.gif'}, title:'Web apps', description:'Necesitas un solución creativa y eficiente para ese próximo gran proyecto? Transforma tu idea en una plataforma completa, desde un sistema de gestión de contenido hasta un sistema de gestión de proyectos.'},
        {id:{main:'bg-[#FFE9C7]', icon:'../img/icon5.gif'}, title:'Soluciones a la medida', description:'Tienes alguna idea pero no sabes cómo implementarla? No te preocupes, nos encanta la innovación, somos un equipo creativo y multidisciplinario abierto a nuevas ideas.'},
        {id:{main:'bg-[#FFE9C7]', icon:'../img/icon6.gif'}, title:'¿Aún dudas o necesitas ayuda?', description:'Escríbennos y con gusto te ayudaremos, estamos abiertos al chismecito y al aterrizaje de tu idea, escuchamos y planteamos soluciones creativas ;)'},
    ]
    return (
        <>
           <section data-scroll-data="1" id="services" className="section services-section bg-gray" style={{ "backgroundImage": "url(img/effect/bg-orange.png)", "backgroundRepeat": "no-repeat", "backgroundSize": "cover"}}>
                <div className="container">
                    <div className="grid section-heading" >
                        <div className="lg:col-span-6 text-center mx-auto">
                            <h3><span>Nuestros Servicios</span></h3>
                        </div>
                    </div>
                    <div className="grid lg:grid-cols-12 md:grid-cols-2 gap-5 grid-cols-1 items-center">
                        {
                            service_list.map((val, i)=>{
                                return <Service key={i} id={val.id} title={val.title} description={val.description} />
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    );
}
